export const FETCH_TWR_DEVICES_HEALTH = '@@twrDevicesHealth/get'
